import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolvePopup from 'components/ResolvePopup';
import { ResolvePopupProps } from 'components/ResolvePopup/ResolvePopup.component';
import { getArrayLength, getJoinedWordsWithComma } from 'utils';

import './ArrayPopup.styles.scss';

const MAX_LENGTH = 1;

type ArrayPopupProps = {
  className?: string;
  popupText: string;
  maxLength?: number;
  list: string[];
  isOrderedList?: boolean;
  emptyPlaceholder?: React.ReactNode;
} & Omit<ResolvePopupProps, 'popupContent' | 'open' | 'onHover'>;

const ArrayPopup: React.FC<ArrayPopupProps> = (props) => {
  const {
    className,
    popupText,
    list = [],
    isOrderedList = false,
    maxLength = MAX_LENGTH,
    emptyPlaceholder,
    ...rest
  } = props;

  const classes = classNames('array-popup', className);

  const { t } = useTranslation();

  const arrayLength = getArrayLength(list);

  const popupContent = useMemo(
    () => (
      <>
        {list.map((el) => (
          <li key={el}>{el}</li>
        ))}
      </>
    ),
    [list],
  );

  if (!arrayLength) return <>{emptyPlaceholder ?? t('na')}</>;

  if (arrayLength <= maxLength) return <p>{getJoinedWordsWithComma(list)}</p>;

  return (
    <ResolvePopup
      {...rest}
      onHover
      className={classes}
      popupContent={
        isOrderedList ? (
          <ol className="resolve-popup-ol">{popupContent}</ol>
        ) : (
          <ul className="resolve-popup-ul">{popupContent}</ul>
        )
      }
    >
      {t(popupText, { count: arrayLength })}
    </ResolvePopup>
  );
};

export default ArrayPopup;
